import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isLoading: false,
  error: [],
  cartCount: []
};
const viewShoppingCartSlice = createSlice({
  name: "addShoppingCart",
  initialState,
  reducers: {
    viewShoppingCartRequest: state => {
      state.isLoading = true;
    },
    viewShoppingCartSuccess: (state, action) => {
      state.cartCount = action.payload;
      state.shoppingCartList = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    viewShoppingCartFailure: (state, action) => {
      state.error = action.payload;
      state.cartCount = [];
      state.isLoading = false;
    }
  }
});
export const {
  viewShoppingCartRequest,
  viewShoppingCartSuccess,
  viewShoppingCartFailure
} = viewShoppingCartSlice.actions;
export default viewShoppingCartSlice.reducer;